// AUTO-GENERATED by scripts/set-env.js — DO NOT EDIT, DO NOT COMMIT.
// Source: src/environments/environment.ts + overrides from .env, bigbeeai.dev.env
export const environment = {
  "enableDevPreviewRoutes": false,
  "production": false,
  "environment": "dev1",
  "captchaKey": "6Lf97CQqAAAAAIlHNjUBmb-4sc2iwli5i0a9qcjp",
  "CONSUMER_PORTAL": "https://dev.bigbee.ai/",
  "API_URL_TV": "https://api-dev.bigbee.ai/partner/v1/",
  "API_URL_TV_BASE": "https://api-dev.bigbee.ai/",
  "API_URL_COMMUNITY": "https://api-dev.bigbee.ai/partner/v1/getOrganizations",
  "API_URL_PAYMENT_TV": "https://api-dev.bigbee.ai/payment/v1/",
  "API_URL_CODE_EXCHANGE": "https://api-dev.bigbee.ai/partner/v1/auth/exchange-code/",
  "VENDOR_PORTAL": "https://devpartner.bigbee.ai/",
  "VENDOR_API_URL": "https://api-dev.bigbee.ai/partner/v1/",
  "PUBNUB_API_URL": "https://api-dev.bigbee.ai/thirdparty/pubnub/",
  "API_URL_ORG_TIERS": "https://api-dev.bigbee.ai/partner/v1/org-tiers",
  "AWS_FILE_BUCKET_PATH": "https://devupload.bigbee.ai/",
  "UPLOAD_URL_EXTENSION": ".com/",
  "ipGeoKey": "3af47278566b46e58bb63b70fb6df99d",
  "enable_aichatbot": true,
  "enable_community": true,
  "AWS_Cognito": {
    "userPoolWebClientId": "1sdkqpjrq26jii0efcrh2fgofp",
    "userPoolId": "us-west-2_OEW7c74R1",
    "identityPoolId": "us-west-2:9e45d9e0-eea9-4aa7-aac5-87046be5681b",
    "region": "us-west-2",
    "apiName": "arkvibe_dev_api",
    "apiBase": "https://zs721bekp5.execute-api.us-east-1.amazonaws.com/dev/",
    "X_Api_Key": "qT9ynUxjdd6Pmij6f55S48mdFhhnaYQh2dB2NRVz",
    "aws_appsync_graphqlEndpoeint": "https://5sgbismmsnfptpolhyz3tdtyja.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_apiKey": "da2-e2cgkkzzdjf4xdrx7gxjkxxwoe",
    "aws_appsync_apiID": "hioa5weudvgyhk67w2wb4s7cfm"
  },
  "RED5PRO": {
    "configuration": {
      "version": "7.0.0-RC1",
      "host": "livestream.arevea.com",
      "port": 8554,
      "stream1": "stream1",
      "stream2": "stream2",
      "app": "live",
      "proxy": "streammanager",
      "streamMode": "live",
      "cameraWidth": 640,
      "cameraHeight": 480,
      "embedWidth": "100%",
      "embedHeight": 480,
      "buffer": 0.5,
      "bandwidth": {
        "audio": 128,
        "video": 4000
      },
      "keyFramerate": 3000,
      "useAudio": true,
      "useVideo": true,
      "mediaConstraints": {
        "audio": true,
        "video": {
          "width": {
            "min": 320,
            "max": 1920
          },
          "height": {
            "min": 720,
            "max": 1080
          },
          "frameRate": {
            "min": 8,
            "max": 30
          }
        }
      },
      "publisherFailoverOrder": "rtc,rtmp",
      "subscriberFailoverOrder": "rtc,rtmp,hls",
      "rtcConfiguration": {
        "iceServers": [
          {
            "urls": "stun:stun2.l.google.com:19302"
          }
        ],
        "bundlePolicy": "max-bundle",
        "iceCandidatePoolSize": 2,
        "iceTransportPolicy": "all",
        "rtcpMuxPolicy": "require"
      },
      "googleIce": [
        {
          "urls": "stun:stun2.l.google.com:19302"
        }
      ],
      "mozIce": [
        {
          "urls": "stun:stun.services.mozilla.com:3478"
        }
      ],
      "iceTransport": "udp",
      "verboseLogging": true,
      "recordBroadcast": false,
      "streamManagerAPI": "4.0",
      "streamManagerAccessToken": "YEOkGmERp08V",
      "muteOnAutoplayRestriction": true,
      "authentication": {
        "enabled": true,
        "username": "user",
        "password": "pass"
      },
      "serverSettings": {
        "protocol": "https",
        "httpport": "443",
        "hlsport": 5080,
        "hlssport": 443,
        "wsport": 5080,
        "wssport": 443,
        "rtmpport": 1935,
        "rtmpsport": 1936
      }
    },
    "cloudfront": "https://d3vv6h15bemsva.cloudfront.net/live/"
  },
  "social": {
    "facebookAppId": "230469618276761"
  },
  "sendBird": {
    "application_Id": "B6758752-5C78-4CE8-808D-C5D53247DC67",
    "UNIQUE_HANDLER_ID": "UNIQUE_HANDLER_ID",
    "SECONDARY_API_TOKENS": "41218b39ea1a09e81d091889be555e03f6b74250"
  },
  "pubNub": {
    "publishKey": "pub-c-316cd33b-2700-4a91-b5c2-0cdb4cbca49f",
    "subscribeKey": "sub-c-98dd00d9-4c9b-41b0-b49c-14635926f3c0",
    "secretKey": "sec-c-ZWIzZjg3YWYtNjRiZS00Y2M4LTllNTQtZDI5YjNiMDk5NmQ3"
  },
  "AWS": {
    "SignedURLBase": "https://bigbee-vod-dev-source71e471f1-f1eelupfn2es.s3.us-east-1.amazonaws.com/",
    "ACCESS_URL": "https://devupload.bigbee.ai/"
  },
  "STRIPE_UK_KEY": "pk_test_51Gq4OqHk55gRguyaRPvedn7Kv7riEU8OKbdotyVMvjRbDpZNfTOTJaIuqHzlgmnHFiTsvQBQUJgtLl1yC4k7SCTo005bqL5gzP",
  "STRIPE_US_KEY": "pk_test_51PnOlyRw1q3VWqBLlC94BWfmbMngCuRWzeB8TvcYkyhsJpL2UMoAk5GCEQ37HjVl1glcTeJlYJcaEGm5F7luxR9O00BryGHalA",
  "mapKey": "AIzaSyCdhCzDUX9DpMB9rjC5EuN1rqwXkOptWqg",
  "oneLogin": {
    "baseURL": "/onelogin/",
    "subDomainURL": "/subonelogin/",
    "subDomain": "areveatv-sandbox",
    "client_id": "4e42c39db6ada915afaf60448254cd10033604c982128c55d1548e218b983279",
    "faceBookCallBack": "\"https://areveatv-sandbox.onelogin.com/access/initiate?iss=facebook&target_link_uri=https://api-dev.bigbee.ai/callback/%22",
    "googleCallBack": "\"https://areveatv-sandbox.onelogin.com/access/initiate?iss=https://accounts.google.com&target_link_uri=https://api-dev.bigbee.ai/callback/%22",
    "linkedinCallBack": "\"https://areveatv-sandbox.onelogin.com/access/initiate?iss=linkedin&target_link_uri=https://api-dev.bigbee.ai/callback/%22",
    "social_authorize": "\"https://areveatv-sandbox.onelogin.com/oidc/2/auth?client_id=1228fbd0-cea5-0138-c908-0624ff60e6f7176062&redirect_uri=https://api-dev.bigbee.ai/authorize/&response_type=code&scope=openid%22",
    "mobile_social_authorize": "\"https://areveatv-sandbox.onelogin.com/oidc/2/auth?client_id=1228fbd0-cea5-0138-c908-0624ff60e6f7176062&redirect_uri=https://api-dev.bigbee.ai/&response_type=code&scope=openid%22",
    "CLIENT_SECRET": "67795bdcf01b42caeb145988f7e64bd71d00191e2abab99dc7e43bf86da3e50c"
  },
  "OIDC": {
    "onelogin_account_name": "bigbeeai",
    "client_id": "50393860-a006-013d-f51e-6f2641c6177c240305"
  },
  "social_auth_redirect_uri": "https://dev.bigbee.ai/",
  "FullStory_OrgID": "ZV0DT",
  "paypal": {
    "env": "sandbox",
    "client_id": "AeUjj7MrkmTf8Cui6RywbBFsxSk1597pN8LY2hQk0-w9Pehqw4uszTb_rDoa28B-FrecpCNQWcrkaqYd"
  },
  "skreens": {
    "api_prefix": "https://director-service.skreens.tv/api"
  },
  "kevel": {
    "api_prefix": "https://api.kevel.co/v1",
    "NETWORK_ID": "10563",
    "API_KEY": "CDBF5F75a4E91a4BE8a94AEa1A9778575B0E"
  },
  "millicast": {
    "ACCOUNT_ID": "Xa87PZ"
  },
  "networking": {
    "allowed_limit": 4
  },
  "ONE_USD": 20,
  "owner_cryptoWallet": "0x9Eb769412294eE4Baad0EdE381d8f3FE52c52D60",
  "languages": [
    {
      "code": "en",
      "name": "English",
      "lang": "English"
    },
    {
      "code": "zh-CN",
      "name": "Chinese (Simplified)",
      "lang": "简体中文"
    },
    {
      "code": "zh-TW",
      "name": "Chinese (Traditional)",
      "lang": "中國傳統的"
    },
    {
      "code": "hi",
      "name": "Hindi",
      "lang": "हिंदी"
    },
    {
      "code": "ko",
      "name": "Korean",
      "lang": "한국어"
    },
    {
      "code": "id",
      "name": "Indonesian",
      "lang": "bahasa Indonesia"
    },
    {
      "code": "ur",
      "name": "Urdu",
      "lang": "اردو"
    },
    {
      "code": "pt",
      "name": "Portuguese (Portugal, Brazil)",
      "lang": "Português (Portugal, Brasil)"
    },
    {
      "code": "bn",
      "name": "Bengali",
      "lang": "বাংলা"
    },
    {
      "code": "ru",
      "name": "Russian",
      "lang": "русский"
    },
    {
      "code": "es",
      "name": "Spanish",
      "lang": "español"
    },
    {
      "code": "ja",
      "name": "Japanese",
      "lang": "日本"
    },
    {
      "code": "tl",
      "name": "Tagalog (Filipino)",
      "lang": "Tagalog (Filipino)"
    },
    {
      "code": "am",
      "name": "Amharic",
      "lang": "አማርኛ"
    },
    {
      "code": "ar",
      "name": "Arabic",
      "lang": "عربى"
    },
    {
      "code": "fr",
      "name": "French",
      "lang": "français"
    },
    {
      "code": "vi",
      "name": "Vietnamese",
      "lang": "Tiếng Việt"
    },
    {
      "code": "fa",
      "name": "Persian",
      "lang": "فارسی"
    },
    {
      "code": "tr",
      "name": "Turkish",
      "lang": "Türk"
    },
    {
      "code": "de",
      "name": "German",
      "lang": "Deutsche"
    },
    {
      "code": "th",
      "name": "Thai",
      "lang": "ไทย"
    }
  ],
  "assets_url": "assets/",
  "clientDetails": {
    "required_crypto_wallet": 1,
    "network": "polygon",
    "template": 1,
    "name": "BigbeeAI",
    "slug": "bigbee.ai",
    "network_logo": "assets/clients/bigbeeai/BigBee.svg",
    "header_logo": "assets/clients/bigbeeai/logo.svg",
    "footer_logo": "assets/clients/bigbeeai/logo.svg",
    "crypto_token": "BB",
    "crypto_symbol": "assets/clients/bigbeeai/bigbee-logo.png",
    "crypto_symbol_black": "assets/clients/bigbeeai/bigbee-logo.svg",
    "network_name": "Ethereum Rinkeby",
    "privacy_mail": "privacy@bigbee.ai",
    "market_mail": "marketing@bigbee.ai",
    "info_mail": "info@bigbee.ai",
    "support_mail": "help.bigbee.ai",
    "address": {
      "line1": "385 Moffett Park Drive",
      "line2": "Suite 105",
      "city": "Sunnyvale",
      "state": "CA",
      "zip": "94089"
    },
    "stream_menu": 0,
    "polychain": 80001,
    "avaxchain": 43113,
    "polyhex": "0x13881",
    "avahex": "0xa869",
    "useArevea": 0,
    "socialIcons": 0,
    "facebook": "",
    "instagram": "",
    "twitter": "",
    "linkedin": "",
    "main_bg_color": "#222c36",
    "bg_primary_color": "#3B3F46",
    "bg_secondary_color": "#222c36",
    "bg_tertiary_color": "#1E2328",
    "font_primary_color": "#ffffff",
    "font_secondary_color": "#fff",
    "font_tertiary_color": "#fff",
    "form_bg_color": "#1E2328",
    "form_font_secondary_color": "#CDCDCD",
    "footer_bg_primary_color": "#000000",
    "footer_font_primary_color": "#eba921",
    "footer_font_secondary_color": "#ffffff",
    "ai_assistant": {
      "assistant_name": "Bigbee Support",
      "assistant_logo": "assets/clients/bigbeeai/ai-assistant.svg",
      "bot_logo": "assets/clients/bigbeeai/bigbee-logo.svg",
      "bot_name": "BigBee",
      "send_icon": "assets/clients/bigbeeai/send.svg"
    },
    "DEFAULT_BANNER_IMAGE": "assets/clients/bigbeeai/default_banner_logo.png"
  },
  "themeColors": {
    "btn_animation_color1": "#8EB4D9",
    "btn_animation_color2": "#11477D",
    "btn_animation_color3": "#0A2139",
    "primary_font_family": "FavoritRegular",
    "secondary_font_family": "sans-serif",
    "tertiary_font_family": "Roboto",
    "primary_theme_color1": "#8CE6D6",
    "secondary_theme_color2": "#000000",
    "tertiary_theme_color3": "#222C36",
    "quaternary_theme_color4": "#FFFFFF",
    "pentagon_theme_color5": "#0D1115",
    "hexagon_theme_color6": "#EEE",
    "heptagon_theme_color7": "#9E9E9E",
    "primary_bg_color": "#0D1115",
    "primary_bg_font_color1": "#000000",
    "primary_bg_font_color2": "#FFFFFF",
    "primary_bg_font_color3": "#8CE6D6",
    "primary_bg_font_color4": "#F44336",
    "primary_bg_font_color5": "#222C36",
    "primary_bg_font_color6": "#9E9E9E",
    "primary_bg_font_color7": "#BCBCBC",
    "primary_bg_font_color8": "#EEE",
    "secondary_bg_color": "#222C36",
    "secondary_bg_font_color1": "#FFFFFF",
    "secondary_bg_font_color2": "#8CE6D6",
    "secondary_bg_font_color3": "#000000",
    "secondary_bg_font_color4": "#BCBCBC",
    "secondary_bg_font_color5": "#9E9E9E",
    "secondary_bg_font_color6": "#EEE",
    "secondary_bg_font_color7": "#0D1115",
    "secondary_bg_font_color8": "#28A745",
    "secondary_bg_font_color9": "#F44336",
    "facebook_bg": "#3a5999",
    "linkedin_bg": "#006fa6",
    "twitter_bg": "#00acee",
    "google_bg": "#F44336",
    "tertiary_bg_color": "#000000",
    "tertiary_bg_font_color1": "#8CE6D6",
    "tertiary_bg_font_color2": "#FFFFFF",
    "tertiary_bg_font_color3": "#9E9E9E",
    "tertiary_bg_font_color4": "#222C36",
    "tertiary_bg_font_color5": "#BCBCBC",
    "tertiary_bg_font_color6": "#EEE",
    "tertiary_bg_font_color7": "#95E2CC",
    "tertiary_bg_font_color8": "#F44336",
    "tertiary_bg_font_color9": "#0D1115",
    "tertiary_bg_font_color10": "#28A745",
    "tertiary_bg_font_color11": "#000000",
    "quaternary_bg_color": "#8CE6D6",
    "quaternary_bg_font_color1": "#000000",
    "quaternary_bg_font_color2": "#FFFFFF",
    "quaternary_bg_font_color3": "#F44336",
    "quaternary_bg_font_color4": "#28A745",
    "pentanary_bg_color": "#FFFFFF",
    "pentanary_bg_font_color1": "#000000",
    "pentanary_bg_font_color2": "#444444",
    "pentanary_bg_font_color3": "#8CE6D6",
    "hexanaray_bg_color": "#9E9E9E",
    "hexanary_bg_font_color1": "#000000",
    "hexanary_bg_font_color2": "#FFFFFF",
    "septanary_bg_color": "#F44336",
    "septanary_bg_color1": "#EEE",
    "octanary_bg_color": "#28A745",
    "octanary_bg_color1": "#EEE",
    "nenone_bg_color": "#EEE",
    "nenone_bg_font_color1": "#8CE6D6",
    "nenone_bg_font_color2": "#000000"
  },
  "processing_fee": 2.9,
  "fee_percentage": 0.3,
  "required_crypto_wallet": 1,
  "DYNAMIC_PUBNUB_ENABLED": true,
  "enableNewVideoDetailPage": true,
  "enableNewCommunityPage": true,
  "enableNewUserDashboard": true,
  "enableNewTopMenu": true,
  "enableNewAgentHome": true,
  "enableNewFooter": true,
  "enableNewSignup": true,
  "enableCommunityPresence": true,
  "umami": {
    "websiteId": "b93d1850-62c0-4073-baa2-c4759c6107d8",
    "apiUrl": "https://analytics.umami.is/script.js"
  },
  "communityDefaultColors": {
    "space_main_bg_color": "#1e2328",
    "space_bg_primary_color": "#3b3f46",
    "space_bg_secondary_color": "#eba921",
    "space_font_main_color": "#ffffff",
    "space_font_primary_color": "#e3e3e3",
    "space_font_secondary_color": "#ffffff",
    "space_button_primary_color": "#1e2328",
    "space_button_secondary_color": "#eba921",
    "space_button_font_primary_color": "#e3e3e3",
    "space_button_font_secondary_color": "#000000"
  },
  "eventDefaultColors": {
    "event_bg_main_color": "#3B3F46",
    "event_bg_primary_color": "#222c36",
    "event_bg_secondary_color": "#000000",
    "event_font_main_color": "#ffffff",
    "event_font_primary_color": "#ffffff",
    "event_font_secondary_color": "#cdcdcd",
    "event_button_bg_primary_color": "#eba921",
    "event_button_bg_secondary_color": "#ffffff",
    "event_button_font_primary_color": "#000000",
    "event_button_font_secondary_color": "#000000",
    "event_card_bg_color": "#ffffff",
    "event_card_font_color": "#000000"
  },
  "merchandiseDefaultColors": {
    "merchandise_bg_main_color": "#3B3F46",
    "merchandise_bg_primary_color": "#222c36",
    "merchandise_bg_secondary_color": "#000000",
    "merchandise_font_main_color": "#ffffff",
    "merchandise_font_primary_color": "#ffffff",
    "merchandise_font_secondary_color": "#cdcdcd",
    "merchandise_button_bg_primary_color": "#eba921",
    "merchandise_button_bg_secondary_color": "#ffffff",
    "merchandise_button_font_primary_color": "#000000",
    "merchandise_button_font_secondary_color": "#000000",
    "merchandise_card_bg_color": "#ffffff",
    "merchandise_card_font_color": "#000000"
  },
  "aiAgentDefaultColors": {
    "ai_agent_bg_color": "",
    "ai_agent_accent_color": "",
    "ai_agent_text_color": "",
    "ai_agent_form_color": ""
  },
  "PAYMENT": {
    "PAYMENT_ENVIRONMENT": "sandbox",
    "PUBLISHABLEKEY": "3zqedd5wy596l0dm94q0b93m"
  },
  "ENCRYPTION_KEY": "8w7#f9Lm!5q2Xr@Yz0P&K3Nv$t6J*4Bd",
  "AI_CHATBOT_NAME": "BigbeeAI",
  "DEFAULT_USER_ID": "f1b128bd-4fec-4157-a88b-0af762100c3b",
  "DEFAULT_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImYxYjEyOGJkLTRmZWMtNDE1Ny1hODhiLTBhZjc2MjEwMGMzYiIsImVtYWlsIjoicHJhZ2F0aGlhbWJhdmFyYXB1QGdtYWlsLmNvbSIsInVzZXJfdHlwZSI6MywiZGlzcGxheV9uYW1lIjoiUHJhZ2F0aGkgQSIsImlhdCI6MTU5MzUwMTIzNX0.s_lRaVOI-cx23pJqV0E00R01PWWcEm7tBQ6VLV3C1vs",
  "HIDE_CRYPTOINSTRUCTION": true,
  "CREDIT_SERVER_ENFORCEMENT": true
};
